import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7542b050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-grow-1 container-p-y px-4\" data-v-7542b050><div data-v-7542b050><h4 class=\"fw-bold py-3 mb-4\" data-v-7542b050><span class=\"text-muted fw-light\" data-v-7542b050></span><h1 class=\"mb-2 text-center\" data-v-7542b050>404</h1></h4><p class=\"text-center\" data-v-7542b050>Sorry, the page you are looking for does not exist.</p></div></div>", 1)
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-backdrop fade" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBarView = _resolveComponent("TopBarView")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBarView),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Footer),
      _hoisted_4
    ])
  ]))
}